import { useState } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { Button, DropDown, TextArea, Typography } from "components/atoms";
import { BackIcon, FileIcon } from "components/atoms/Icon";
import { AppealTable } from "components/molecules";
import "./index.scss";
import { useScreenSize } from "hooks";
import { MOBILE_WIDTH, TAB_WIDTH } from "utils/constants";
import { AppealTableMobile } from "../AppealTableMobile";

interface IProps {
  theme: "light" | "dark";
}

export const Appeal = ({ theme }: IProps) => {
  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = useState(false);
  const [selectedReason, setSelectedReason] = useState<
    null | string | { [key: number]: string }
  >(null);
  const screen = useScreenSize();

  const handleBack = () => navigate("/");
  const handleSubmit = () => setIsSubmit(true);
  const handleDone = () => navigate("/");

  return (
    <div className={classNames("appeal-wrapper")}>
      <div className={classNames("appeal-back-wrapper")}>
        <BackIcon
          color={theme === "light" ? "#273e5a" : "#329EE2"}
          onClickHandle={handleBack}
        />
        <Typography variant="h8Underline" label="Back" onClick={handleBack} />
      </div>
      <Typography styles="appal-header-text" variant="h2Bold" label="Appeal" />
      {isSubmit ? (
        <div className={classNames("appeal-success-msg-wrapper")}>
          <Typography
            variant="h8Med"
            styles="appeal-success-text"
            label="Your appeal has been submitted successfully! We will get back to you within 2-3 days."
          />
        </div>
      ) : (
        <>
          <Typography
            variant="h7Med"
            label="Provide the reason(s) why you missed the following for MCAT Bio Class 1 Homeworks: "
          />
          {screen.width < MOBILE_WIDTH || screen.width < TAB_WIDTH ? (
            <AppealTableMobile />
          ) : (
            <AppealTable />
          )}
          <Typography
            styles="appeal-reason-text"
            variant="h8Book"
            label="Select reason(s)"
          />
          <DropDown
            data={["Sick"]}
            placeholder="Select Reason"
            setDropDownSelection={setSelectedReason}
            defaultSelected={selectedReason}
          />
          <div className={classNames("appeal-desc-wrapper")}>
            <Typography
              variant="h7Book"
              label="Additional Information (optional):"
            />
            <TextArea rows={10} />
          </div>
          <div className={classNames("attach-file-wrapper")}>
            <FileIcon />
            <Typography
              variant="h7Underline"
              label="Add supporting documents"
              styles="attach-file-custom-typography-style"
            />
          </div>
        </>
      )}
      {isSubmit ? (
        <Button
          styles="appeal-submit-btn"
          icon={false}
          label="Done"
          onClick={handleDone}
        />
      ) : (
        <>
          <Button
            styles="appeal-submit-btn"
            icon={false}
            label="Submit"
            onClick={handleSubmit}
            type="appeal"
            isDisable={selectedReason === null}
          />
          <Button
            styles="appeal-cancel-btn"
            icon={false}
            label="Go back"
            onClick={handleBack}
          />
        </>
      )}
    </div>
  );
};
